export enum EvaluationActionType {
    saveKit = 'saveKit',
    saveEvaluation = 'saveEvaluation',
    sendAI = 'sendAI',
}

export interface IEvaluationFooterActionsProps {
    saveAsTemplate: () => void;
    handleEvaluationSubmit: () => void;
    isSaveEvaluationDisabled: boolean;
    isEditing: boolean;
    isLoading: boolean;
    isSuccessSavingEvaluation?: boolean;
}